
import React, { useRef, useEffect } from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Bot } from "lucide-react";
import ChatMessage, { Message } from "./ChatMessage";

interface MessageListProps {
  messages: Message[];
  isLoading: boolean;
  onFeedbackSubmit?: (messageId: number, helpful: boolean) => Promise<void>;
}

const MessageList: React.FC<MessageListProps> = ({ messages, isLoading, onFeedbackSubmit }) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  // Scroll to bottom when messages change
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth"
    });
  }, [messages, isLoading]);

  return (
    <ScrollArea className="h-[400px] pr-4">
      <div className="space-y-4">
        {messages.map((message, index) => (
          <ChatMessage 
            key={index} 
            message={message} 
            index={index}
            onFeedbackSubmit={onFeedbackSubmit}
          />
        ))}
        {isLoading && (
          <div className="flex justify-start">
            <div className="bg-muted p-3 rounded-lg flex items-center gap-2 text-muted-foreground">
              <Bot className="h-5 w-5" />
              <div className="flex space-x-1">
                <div className="animate-bounce h-2 w-2 rounded-full bg-current"></div>
                <div className="animate-bounce delay-75 h-2 w-2 rounded-full bg-current"></div>
                <div className="animate-bounce delay-150 h-2 w-2 rounded-full bg-current"></div>
              </div>
            </div>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>
    </ScrollArea>
  );
};

export default MessageList;
